














import { Vue, Component } from "vue-property-decorator";
import RegisterStepOne from "@/zh-website/src/views/partner/supplier/RegisterStepOne.vue";
import RegisterStepTwo from "@/zh-website/src/views/partner/supplier/RegisterStepTwo.vue";
import RegisterStepThree from "@/zh-website/src/views/partner/supplier/RegisterStepThree.vue";
import RegisterStepFour from "@/zh-website/src/views/partner/supplier/RegisterStepFour.vue";
import DrawerScanForm from "@/zh-website/src/views/partner/supplier/drawerScanForm.vue";
import { PartnerService } from "@/zh-website/src/views/partner/service";

@Component({
  components: {
    RegisterStepOne,
    RegisterStepTwo,
    RegisterStepThree,
    RegisterStepFour,
    DrawerScanForm
  }
})
export default class SupplierRegister extends Vue {
  drawer = false;
  step = 1;
  errInfo = {
    text: "提交失败",
    desc: "遇到未知问题，请返回重新提交",
    btn: "重新提交",
    class: "el-icon-error",
    color: "#F53F3F"
  };
  successInfo = {
    text: "提交成功",
    desc: "请耐心等待，我们会尽快处理与审核并与您取得联系",
    btn: "返回主页",
    class: "el-icon-success",
    color: "#00B42A"
  };
  resultInfo = {};
  mounted() {
    // 添加用于判断是 c端 还是 b端的 local storage
  }

  formData = {};
  scanFormData = [[], [], []];
  async onStep(step: number, data: any) {
    // 预览数据处理
    if (this.step == 1 && step == 1) {
      this.scanFormData[0] = data;
    }
    if (this.step == 2 && step == 1) {
      this.scanFormData[1] = data;
    }

    // 提交数据处理
    step == 1 &&
      data.map((item: any) => {
        this.formData[item.name] = item.data;
      });

    if (this.step == 3 && step == 1) {
      await this.submitForm();
      this.step += step;
    } else {
      this.step += step;
    }
  }
  onScan(data: any) {
    this.scanFormData[2] = data;
    data.map((item: any) => {
      this.formData[item.name] = item.data;
    });

    this.drawer = true;
    this.step = 5;
  }
  handleClose() {
    this.drawer = false;
    this.step = 3;
  }
  submitForm() {
    return new Promise((resolve, reject) => {
      Vue.prototype.$c({
        title: "确认提交？",
        centered: true,
        content:
          "请认真填写所有登记信息，确保登记信息要与真实情况保持一致；一旦提交后，登记信息将不能再修改。",
        okText: "确认提交",
        cancelText: "返回修改",
        okType: "danger",
        onOk: () => {
          const addressObj = {};
          const fileObj = {};
          // 地址转换JSON
          [
            "registeredAddress",
            "officeAddress",
            "productionAddress",
            "researchAddress"
          ].map(item => {
            addressObj[item] = JSON.stringify(this.formData[item]);
          });
          // 附件保存id
          ["businessLicenseAnnex", "companyAnnex", "financialAnnex"].map(
            item => {
              if (typeof this.formData[item] !== "string") {
                fileObj[item] = this.formData[item][0].id;
              }
            }
          );
          PartnerService.addSupplier({
            ...this.formData,
            ...addressObj,
            ...fileObj
          })
            .then((res: any) => {
              this.resultInfo = { ...this.successInfo };
            })
            .catch((err: any) => {
              this.resultInfo = { ...this.errInfo };
            });
          resolve("");
        }
      });
    });
  }
  async handleSubmit() {
    await this.submitForm();
    this.step = 4;
  }
}
